import { createSelector } from 'reselect';
import InvoiceItem from '~/types/InvoiceItem';
import {
  extractRequestable,
  requestableHasFailed,
  requestableHasSucceeded,
  requestableIsLoading,
} from '~/utils/fetchable';
import { ApplicationState } from '../store';

export const getInvoiceItemsStore = (state: ApplicationState) => state.invoiceItems;

export const getInvoiceItems = createSelector(
  getInvoiceItemsStore,
  (invoiceItemsStore): Requestable<InvoiceItem[], Error> => invoiceItemsStore.invoiceItems,
);

export const getPage = createSelector(
  getInvoiceItemsStore,
  ({
    page,
    pageCount,
  }): {
    page: number;
    pageCount: number;
  } => ({
    page,
    pageCount,
  }),
);

export const getIsExportErrorVisible = createSelector(getInvoiceItemsStore, (invoiceItemsStore) =>
  requestableHasFailed(invoiceItemsStore.exportURL),
);

export const getIsExportLoading = createSelector(
  getInvoiceItemsStore,
  (invoiceItemsStore): boolean => requestableIsLoading(invoiceItemsStore.exportURL),
);

export const getIsExportSettled = createSelector(
  getInvoiceItemsStore,
  (invoiceItemsStore): boolean => {
    return (
      requestableHasSucceeded(invoiceItemsStore.exportURL) ||
      requestableHasFailed(invoiceItemsStore.exportURL)
    );
  },
);

export const getExportURL = createSelector(
  getInvoiceItemsStore,
  (invoiceItemsStore): Maybe<string> => extractRequestable(invoiceItemsStore.exportURL),
);

export const getDisplayInvoiceItems = createSelector(
  getInvoiceItemsStore,
  (invoiceItemsStore): Requestable<InvoiceItem[], string> => invoiceItemsStore.displayInvoiceItems,
);
